// the trip planner application
// a neomem plugin, independent of any ui code

import { Neomem, INode, Props, IPlugin } from '../neomem/src/types'
import * as data from './data'
import flags from './flags'



const typeToSubtype = {
  'street_address': 'address', // eg 760 west forest dr
  'establishment': 'establishment', // eg mcdonalds
  'neighborhood': 'neighborhood', // eg river oaks houston
  'locality': 'city', // eg austin tx
  'sublocality': 'city', // eg brooklyn ny
  'sublocality_level_1': 'city', // eg brooklyn ny
  'administrative_area_level_1': 'state', // eg texas, wales uk, scotland uk
  'country': 'country', // eg uk
}

function getSubtype(typesStr: string) {
  let subtype = 'place' // catch-all
  const types = typesStr.split(',')
  for (const [key, value] of Object.entries(typeToSubtype)) {
    if (types.indexOf(key) >= 0) {
      subtype = value
      break
    }
  }
  return subtype
}



//. could use some dynamic code to transfer these methods onto Neomem class?
//  but dont want plugins to clobber neomem stuff


export class TripPlanner implements IPlugin {

  name = 'tripPlanner' // used as key for plugins dict
  neomem: Neomem

  constructor(neomem: Neomem) {
    this.neomem = neomem
  }

  initialize() {
  }

  loadOntology() {
    // this.neomem.load(data.ontology)
    this.neomem.addToCache(data.ontology)
  }
  
  loadData() {
    if (flags.loadDummyData) {
      // this.neomem.load(data.dummy)
      this.neomem.addToCache(data.dummy)
    }
  }

  //. make Trip and Place classes extending INode

  addTrip(props: Props = {}): INode {
    const defaults = {
      name: '(Unnamed trip)',
      typeId: 'trip',
      parentId: 'welcome', //.
    }
    props = { ...defaults, ...props }
    const trip = this.neomem.createNode(props)
    if (trip.parentId) {
      this.neomem.addChild(trip.id, trip.parentId)
    }
    return trip
  }


  // for console testing passing name+parentid is nice, 
  // but need full props object for react ui
  addPlace(props: Props): INode {
    const parentId = this.findGoodParentId(props)
    props.name = props.name.replace(', USA', '')
    props.parentId = parentId
    props.typeId = 'place'
    // props.typesStr
    const place = this.neomem.createNode(props) // adds an id, notifies the db also
    this.neomem.addChild(place.id, parentId)
    this.neomem.setCurrentNodeId(place.id)
    return place
  }


  //. this logic is tangled - cleanup and add unit tests
  findGoodParentId(props: Props) {

    const currentNodeId = this.neomem.currentNodeId
    const currentNode = this.neomem.getNode(currentNodeId)
    let parentId

    // if no parent specified, try to find a good place to put it
    if (!props.parentId) {

      // if on welcome, add to end of first available trip
      if (currentNodeId === 'welcome') { //.
        let trip = this.getFirstTrip()

        // no trips defined yet, so create one and add it there
        if (!trip) {
          trip = this.addTrip() // will always add to welcome
        }

        // so now we have a good parent
        parentId = trip.id
      
      // otherwise, if current node has children, add to end of them
      } else if (this.neomem.hasChildren(currentNodeId)) {
        parentId = currentNodeId

      // otherwise if on a trip, add as a child
      } else if (currentNode.typeId === 'trip') {
        parentId = currentNodeId
      
      // otherwise add as a sibling of the current node
      } else {
        const parent = this.neomem.getParent(currentNodeId)
        parentId = parent ? parent.id : 'welcome' // just in case //.
      }
    }
    return parentId
  }

  // find first trip defined under 'welcome' node
  getFirstTrip(): INode|undefined {
    //. walk down nodes till find a trip and return it, or undefined if none found
    const nodes = this.neomem.getChildren('welcome') //.
    for (let node of nodes) {
      if (node.typeId === 'trip') {
        return node
      }
    }
    return undefined
  }

}
